import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme) => {
    return {
        container: {
            position: 'fixed',
            margin: 0,
            borderRadius: '4px',
            padding: 0,
            overflow: 'visible',
            display: "flex"
        },
        resizeContainer: {
            width: '100%',
            height: '100%',
            overflow: 'auto'
        },
        resizeHandle: {
            width: '16px',
            height: '16px',
            position: 'absolute',
            bottom: 0,
            right: 0,
            zIndex: 1,
            
            '&::after': {
                content: '""',
                display: 'block',
                cursor: 'se-resize',
                position: 'absolute',
                width: '100%',
                height: '100%',
                border: "8px solid transparent",
                // borderTopColor: "#bfbfbf", uncomment to show triangular resize handle
                transform: "translate(8px, 8px) rotate(-45deg)",
                
            }
        },
        heading: {
            fontWeight: 500,
            padding:'4px',
            paddingLeft: '8px',
            cursor: "grab",
            borderRadius: '4px 4px 0 0',
            position: 'sticky',
            top: 0,
            zIndex: 10
        },
        dragging: {
            cursor: "grabbing"
        },
        hidden: {
            opacity: 0
        },
        content: {
            flexGrow: 1,
            overflow: 'auto',
            maxHeight: '100%'
        },
        closeButton: {
            marginLeft: 'auto',
            position: 'absolute',
            top: 4,
            right: 4,
            width: 20,
            height: 20,
            borderRadius: '50%',
            transition: 'background-color 0.2s ease-in-out',
            '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.1)',
            },
            '& svg': {
                fontSize: '16px'
            }
        },
        settingsButton: {
            marginLeft: 'auto',
            position: 'absolute',
            top: 4,
            right: 25,
            width: 20,
            height: 20,
            borderRadius: '50%',
            transition: 'background-color 0.2s ease-in-out',
            '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.1)',
            },
            '& svg': {
                fontSize: '16px'
            }
        }
    }
})